import styled from '@emotion/styled';
import { useState } from 'react';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';
import { css_background, css_gap } from '~/emotion/theme';
import BetaTabs from '~/editor/templates/beta/lib/BetaTabs';
import MicrositeSection from '~/components/MicrositeSection';
import type { FloorplanBlockVariant } from '~/editor/blocks/floorplan/common';
import BetaSectionHeader from '~/editor/templates/beta/lib/BetaSectionHeader';

const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const PlanCard = styled.div`
	width: 100%;
	max-width: 42rem;
	background: ${css_background()};
	padding: ${css_gap('section', 1.5)};
	box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
`;

export default function FloorplanBlockBeta({ id, title, images }: FloorplanBlockVariant) {
	const [active, setActive] = useState(0);

	if (images.length === 0) {
		return null;
	}

	const activeFloor = images[active] ?? images[0];

	return (
		<MicrositeSection id={id} padding fill>
			{title && <BetaSectionHeader title={title} />}

			<Content>
				<BetaTabs active={active} items={images} getLabel={(_, index) => `Image ${index + 1}`} onChange={setActive} />

				<PlanCard>
					<MicrositeResponsiveImg image={activeFloor} priority={LoadPriority.FIRST_PAINT} />
				</PlanCard>
			</Content>
		</MicrositeSection>
	);
}
